(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 768px)';
  var stateStore = window.__maPdpMobileSelections = window.__maPdpMobileSelections || {};

  // The guided add-to-cart label keeps the size the stylesheet gives it and only
  // shrinks when it would not fit on one line, never below 11px; below that it wraps.
  var CTA_LABEL_MIN_PX = 11;

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function getDesignSection(customizer) {
    return customizer && customizer.closest('[data-is-art-piece-template="true"]');
  }

  function isRedesignActive(customizer) {
    if (!customizer) return false;

    if (isMobile()) {
      return customizer.dataset.redesignMobile === 'true';
    }

    return customizer.dataset.redesignDesktop === 'true';
  }

  function normalize(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/["”]/g, '')
      .replace(/\s+/g, '');
  }

  /*
    DOM writes in this file go through these two helpers so that nothing is
    written when the value is already correct. The product section is watched by
    a MutationObserver (see observePriceAndTerms); a no-op write would otherwise
    wake it up and schedule another sync, forever.
  */
  function setAttrIf(element, name, value) {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  }

  function toggleAttrIf(element, name, on) {
    if (!element || element.hasAttribute(name) === !!on) return;
    if (on) element.setAttribute(name, ''); else element.removeAttribute(name);
  }

  function setTextIf(element, text) {
    if (element && element.textContent !== text) element.textContent = text;
  }

  function getRoot(customizer) {
    return customizer && customizer.closest('.product-page');
  }

  function getState(customizer) {
    var key = customizer.dataset.productId + ':' + customizer.dataset.sectionId;
    if (!stateStore[key]) {
      stateStore[key] = { frame: '', size: '' };
    }
    return stateStore[key];
  }

  function cleanSize(value) {
    return String(value || '')
      .replace(/["”]/g, '')
      .replace(/\s*[xX]\s*/g, '×')
      .trim();
  }

  function triggerNativeOption(customizer, position, value) {
    var root = getRoot(customizer);
    if (!root || !position) return;

    var wrapper = root.querySelector('[data-option-position="' + position + '"]');
    if (!wrapper) return;

    var radios = Array.prototype.slice.call(wrapper.querySelectorAll('input[type="radio"]'));
    var radio = radios.find(function (input) {
      return input.value === value;
    });

    if (radio) {
      // Use the actual native control. If Shopify already has this value selected
      // underneath (the visual customizer intentionally starts unselected), fire
      // change explicitly so the gallery still receives the option position.
      if (radio.checked) {
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        radio.click();
      }
      return;
    }

    var popoutOptions = Array.prototype.slice.call(wrapper.querySelectorAll('[data-popout-option]'));
    var popoutOption = popoutOptions.find(function (option) {
      return option.dataset.value === value;
    });

    if (popoutOption) {
      popoutOption.click();
      return;
    }

    var hiddenInput = wrapper.querySelector('[data-popout-input], [data-single-option-selector]');
    if (hiddenInput) {
      hiddenInput.value = value;
      hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function updateSizeRatios(customizer) {
    // customizer.querySelectorAll('[data-ma-size-ratio]').forEach(function (ratioEl) {
    //   var value = ratioEl.dataset.sizeValue || '';
    //   var numbers = value.match(/\d+(?:\.\d+)?/g);
    //   if (!numbers || numbers.length < 2) return;

    //   var width = parseFloat(numbers[0]);
    //   var height = parseFloat(numbers[1]);
    //   if (!width || !height) return;

    //   var maxW = 34;
    //   var maxH = 28;
    //   var scale = Math.min(maxW / width, maxH / height);
    //   ratioEl.style.width = Math.max(16, width * scale) + 'px';
    //   ratioEl.style.height = Math.max(14, height * scale) + 'px';
    // });
  }

  function updateReviewCount(scope) {
    scope.querySelectorAll('[data-ma-review-count]').forEach(function (el) {
      var raw = el.dataset.maReviewCount || '';
      var number = Number(String(raw).replace(/[^0-9.]/g, ''));
      if (!Number.isFinite(number)) return;
      el.textContent = Math.round(number).toLocaleString('en-US') + ' reviews';
    });
  }

  var usHolidayCache = {};

  function dateKey(date) {
    return [
      date.getFullYear(),
      String(date.getMonth() + 1).padStart(2, '0'),
      String(date.getDate()).padStart(2, '0')
    ].join('-');
  }

  function nthWeekdayOfMonth(year, month, weekday, nth) {
    var date = new Date(year, month, 1, 12, 0, 0);
    var offset = (7 + weekday - date.getDay()) % 7;
    date.setDate(1 + offset + ((nth - 1) * 7));
    return date;
  }

  function lastWeekdayOfMonth(year, month, weekday) {
    var date = new Date(year, month + 1, 0, 12, 0, 0);
    var offset = (7 + date.getDay() - weekday) % 7;
    date.setDate(date.getDate() - offset);
    return date;
  }

  function getUSHolidays(year) {
    if (usHolidayCache[year]) return usHolidayCache[year];

    // Federal holiday calendar. Fixed-date holidays use their calendar date;
    // floating holidays are calculated for the requested year.
    var holidays = [
      new Date(year, 0, 1, 12, 0, 0),                                      // New Year's Day
      nthWeekdayOfMonth(year, 0, 1, 3),                                    // Martin Luther King Jr. Day
      nthWeekdayOfMonth(year, 1, 1, 3),                                    // Washington's Birthday / Presidents Day
      lastWeekdayOfMonth(year, 4, 1),                                      // Memorial Day
      new Date(year, 5, 19, 12, 0, 0),                                     // Juneteenth
      new Date(year, 6, 4, 12, 0, 0),                                      // Independence Day
      nthWeekdayOfMonth(year, 8, 1, 1),                                    // Labor Day
      nthWeekdayOfMonth(year, 9, 1, 2),                                    // Columbus Day
      new Date(year, 10, 11, 12, 0, 0),                                    // Veterans Day
      nthWeekdayOfMonth(year, 10, 4, 4),                                   // Thanksgiving
      new Date(year, 11, 25, 12, 0, 0)                                     // Christmas Day
    ];

    usHolidayCache[year] = new Set(holidays.map(dateKey));
    return usHolidayCache[year];
  }

  function isUSHoliday(date) {
    return getUSHolidays(date.getFullYear()).has(dateKey(date));
  }

  /*
    Shrinks a single-line label until it fits `availableWidth`, never below
    `minSize`. Text width scales linearly with font size, so one measurement at
    `maxSize` is enough to compute the final size (one layout read, one write).
  */
  function fitTextToWidth(element, availableWidth, maxSize, minSize) {
    if (!element || !(availableWidth > 0)) return;

    element.style.whiteSpace = 'nowrap';
    element.style.fontSize = maxSize + 'px';

    var neededWidth = element.scrollWidth;
    if (neededWidth <= availableWidth) return;

    var fittedSize = Math.floor((maxSize * availableWidth / neededWidth) * 4) / 4; // quarter-pixel steps
    if (fittedSize >= minSize) {
      element.style.fontSize = fittedSize + 'px';
      return;
    }

    // Too long even at the smallest legible size: keep that size and wrap instead.
    element.style.fontSize = minSize + 'px';
    element.style.whiteSpace = 'normal';
  }

  function fitDeliveryLine(customizer) {
    var root = getRoot(customizer);
    if (!root || !isRedesignActive(customizer)) return;

    // The customizer CTA is rendered twice when the desktop redesign is enabled:
    // once in the desktop purchase card and once as the normal standalone block
    // used on mobile. Keep every delivery row in sync instead of only touching
    // the first (desktop/hidden-on-mobile) instance in the DOM.
    var lines = root.querySelectorAll('[data-ma-delivery-line]');
    if (!lines.length) return;

    requestAnimationFrame(function () {
      lines.forEach(function (line) {
        var text = line.querySelector('p');
        if (!text) return;
        // Width fitting is handled by the responsive CSS. This loop deliberately
        // covers both the mobile standalone row and desktop purchase-card row.
      });
    });
  }

  function updateDeliveryDate(customizer) {
    var root = getRoot(customizer);
    if (!root) return;

    // There can be more than one delivery-date output in the DOM because the
    // same customizer button block is also rendered inside the desktop purchase
    // card. On mobile the first one is hidden, which previously meant only the
    // hidden desktop date was updated while the visible mobile date stayed blank.
    var outputs = root.querySelectorAll('[data-ma-delivery-date]');
    if (!outputs.length) return;

    var raw = customizer.dataset.storeDate;
    var date = raw ? new Date(raw + 'T12:00:00') : new Date();
    var startingDay = date.getDay();
    var requiredDays = (startingDay === 5 || startingDay === 6) ? 9 : 7;
    var countedDays = 0;

    // Sunday-Thursday: 7 calendar days. Friday-Saturday: 9 calendar days.
    // A US holiday inside that range does not count and pushes delivery out
    // by one additional calendar day.
    while (countedDays < requiredDays) {
      date.setDate(date.getDate() + 1);
      if (!isUSHoliday(date)) countedDays += 1;
    }

    var formattedDate = date.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric'
    });

    outputs.forEach(function (output) {
      output.textContent = formattedDate;
    });

    fitDeliveryLine(customizer);
  }

  function syncShopPay(customizer) {
    var root = getRoot(customizer);
    var slot = customizer.querySelector('[data-ma-financing-slot]');
    if (!root || !slot) return;

    var source = root.querySelector('.ma-pdp-native-block--add-buttons .shop-pay-terms');
    if (!source) return;

    if (source.parentElement !== slot) {
      slot.innerHTML = '';
      slot.appendChild(source);
    }
  }

  function restoreShopPay(customizer) {
    var root = getRoot(customizer);
    if (!root) return;

    var slot = customizer.querySelector('[data-ma-financing-slot]');
    var terms = slot && slot.querySelector('.shop-pay-terms');
    if (!terms) return;

    var form = root.querySelector('.ma-pdp-native-block--add-buttons form[data-product-form]');
    if (!form) return;

    var variantInput = form.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.before(terms);
    } else {
      form.appendChild(terms);
    }
  }

  function isNodeVisible(node) {
    if (!node) return false;
    return node.style.display !== 'none' && !node.hidden && !node.classList.contains('pdp-discount-tag--hidden');
  }

  function getCurrentVariant(root) {
    var form = root && (
      root.querySelector('.ma-pdp-native-block--add-buttons form[data-product-form]') ||
      root.querySelector('form[data-product-form]')
    );
    var input = form && form.querySelector('input[name="id"]');
    var variantId = input && input.value;

    if (!variantId || !Array.isArray(window.productVariantsData)) return null;

    return window.productVariantsData.find(function (item) {
      return String(item.id) === String(variantId);
    }) || null;
  }

  function getVariantOptionValue(variant, position) {
    if (!variant || !position) return '';
    return variant['option' + position] ||
      (Array.isArray(variant.options) ? variant.options[position - 1] : '') ||
      '';
  }

  function variantMatchesSelection(customizer, root, state) {
    var variant = getCurrentVariant(root);
    if (!variant) return false;

    var framePosition = Number(customizer.dataset.frameOptionPosition || 1);
    var sizePosition = Number(customizer.dataset.sizeOptionPosition || 2);
    var frameValue = getVariantOptionValue(variant, framePosition);
    var sizeValue = getVariantOptionValue(variant, sizePosition);

    return normalize(frameValue) === normalize(state.frame) &&
      normalize(sizeValue) === normalize(state.size);
  }

  function getNativeOptionValue(root, position) {
    if (!root || !position) return '';

    var wrapper = root.querySelector('[data-option-position="' + position + '"]');
    if (!wrapper) return '';

    var checked = wrapper.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value || '';

    var hidden = wrapper.querySelector('[data-popout-input], [data-single-option-selector]');
    return hidden ? (hidden.value || '') : '';
  }

  function findVariantForSelection(customizer, root, state) {
    if (!customizer || !root || !state || !state.frame || !state.size) return null;
    if (!Array.isArray(window.productVariantsData)) return null;

    var framePosition = Number(customizer.dataset.frameOptionPosition || 1);
    var sizePosition = Number(customizer.dataset.sizeOptionPosition || 2);
    var currentVariant = getCurrentVariant(root);

    return window.productVariantsData.find(function (variant) {
      if (normalize(getVariantOptionValue(variant, framePosition)) !== normalize(state.frame)) return false;
      if (normalize(getVariantOptionValue(variant, sizePosition)) !== normalize(state.size)) return false;

      // Preserve any additional Shopify option that is not represented by the
      // new frame/size cards. This keeps the implementation future-safe if a
      // third option is introduced later.
      for (var position = 1; position <= 3; position += 1) {
        if (position === framePosition || position === sizePosition) continue;

        var expected = getNativeOptionValue(root, position);
        if (!expected && currentVariant) expected = getVariantOptionValue(currentVariant, position);
        if (expected && normalize(getVariantOptionValue(variant, position)) !== normalize(expected)) return false;
      }

      return true;
    }) || null;
  }

  function syncVariantIdToForm(root, button, variant) {
    if (!root || !button || !variant || !variant.id) return;

    var form = button.closest('form[data-product-form]') ||
      root.querySelector('.ma-pdp-native-block--add-buttons form[data-product-form]');
    var input = form && form.querySelector('input[name="id"]');
    if (!input || String(input.value) === String(variant.id)) return;

    input.value = variant.id;
    // x-model listens to the input event. Keeping Alpine's variantId in sync
    // prevents a later render from restoring the previous/default variant.
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function stripPurchaseCloneHooks(node) {
    if (!node || node.nodeType !== 1) return;

    node.removeAttribute('id');
    node.removeAttribute('data-product-price');
    node.removeAttribute('data-compare-price');

    Array.prototype.slice.call(node.children || []).forEach(stripPurchaseCloneHooks);
  }

  function syncPurchasePrice(customizer) {
    var root = getRoot(customizer);
    var pricing = root && root.querySelector('[data-ma-purchase-pricing]');
    var output = pricing && pricing.querySelector('[data-ma-purchase-price]');
    if (!pricing || !output) return;

    // The new design intentionally shows the same live price/payment terms at
    // both the top and bottom of the PDP, even before frame/size selection is
    // complete. The guided ATC still prevents adding the default variant.
    var priceRow = root.querySelector('#pdp-price-row');
    if (!priceRow) {
      if (!pricing.hidden) {
        pricing.hidden = true;
        output.innerHTML = '';
        output.dataset.maPriceSignature = '';
      }
      return;
    }

    // The lower purchase price follows the same rule as the header: show
    // “From” only until the customer makes the first frame OR size choice.
    var currentSelection = getState(customizer);
    var hideFrom = !!(currentSelection.frame || currentSelection.size);

    // Rebuild the clone only when the live price row or the "From" state
    // actually changed. The signature is compared on every sync, which is cheap;
    // cloning and re-inserting on every sync is what used to keep the
    // MutationObserver busy.
    var signature = (hideFrom ? '1' : '0') + '|' + priceRow.innerHTML;
    if (output.dataset.maPriceSignature !== signature) {
      var clone = priceRow.cloneNode(true);
      stripPurchaseCloneHooks(clone);
      clone.classList.add('ma-pdp-purchase-price-row');

      var from = document.createElement('span');
      from.className = 'ma-pdp-purchase-from';
      from.setAttribute('data-ma-from', '');
      from.textContent = 'From\u00a0';
      from.hidden = hideFrom;
      clone.insertBefore(from, clone.firstChild);

      output.replaceChildren(clone);
      output.dataset.maPriceSignature = signature;
    }

    var variant = getCurrentVariant(root);
    var paymentTerms = pricing.querySelector('shopify-payment-terms');
    if (variant && paymentTerms) {
      setAttrIf(paymentTerms, 'variant-id', String(variant.id));
    }

    if (pricing.hidden) pricing.hidden = false;
  }

  function getCurrentVariantAvailability(root, button) {
    var variant = getCurrentVariant(root);
    if (variant) return variant.available !== false;

    if (button && button.dataset.maVariantAvailable) {
      return button.dataset.maVariantAvailable === 'true';
    }

    return true;
  }

  function restoreGuidedAddToCart(root) {
    if (!root) return;

    var button = root.querySelector('[data-add-to-cart][data-ma-guided-atc="true"]');
    if (!button) return;

    setAttrIf(root, 'data-redirect-to-cart', 'false');

    var variant = getCurrentVariant(root);
    var available = variant
      ? variant.available !== false
      : button.dataset.maVariantAvailable !== 'false';
    var text = button.dataset.maNativeLabel || button.dataset.maReadyLabel || 'ADD TO CART';

    var textNode = button.querySelector('[data-add-to-cart-text]');
    if (textNode) {
      setTextIf(textNode, text);
      textNode.style.removeProperty('font-size');
      textNode.style.removeProperty('white-space');
    }

    if (button.disabled !== !available) button.disabled = !available;
    button.classList.remove('is-ma-selection-disabled');
    setAttrIf(button, 'aria-disabled', button.disabled ? 'true' : 'false');
    setAttrIf(button, 'aria-label', text);
    rememberCtaState(button, text);
  }

  function syncGuidedAddToCart(customizer) {
    var root = getRoot(customizer);
    if (!root) return;

    var button = root.querySelector('[data-add-to-cart][data-ma-guided-atc="true"]');
    if (!button) {
      root.dataset.redirectToCart = 'false';
      return;
    }

    // Guided selection follows whichever redesigned PDP is active for the
    // current viewport. When that device redesign is off, restore the theme's
    // native Add to Cart behavior.
    if (!isRedesignActive(customizer)) {
      restoreGuidedAddToCart(root);
      return;
    }

    setAttrIf(root, 'data-redirect-to-cart', button.dataset.maRedirectToCart === 'true' ? 'true' : 'false');

    var state = getState(customizer);
    var hasFrame = Boolean(state.frame);
    var hasSize = Boolean(state.size);
    var selectionComplete = hasFrame && hasSize;
    var selectedVariant = selectionComplete
      ? findVariantForSelection(customizer, root, state)
      : null;
    var ready = selectionComplete && Boolean(selectedVariant);
    var available = ready ? selectedVariant.available !== false : true;
    var text = button.dataset.maPromptInitial || 'Please choose a frame & Size.';

    if (hasFrame && !hasSize) {
      text = button.dataset.maPromptFrame || 'Please choose a size.';
    } else if (!hasFrame && hasSize) {
      text = button.dataset.maPromptSize || 'Please choose a frame.';
    } else if (selectionComplete) {
      text = (!ready || !available)
        ? (button.dataset.maSoldOutLabel || 'Sold out')
        : (button.dataset.maReadyLabel || 'ADD TO CART');
    }


    // Do not wait for the section navigation/morph to finish before enabling
    // the CTA. Resolve the exact variant from the customer's two selections
    // and synchronize the actual product-form id input ourselves.
    if (ready) syncVariantIdToForm(root, button, selectedVariant);

    var textNode = button.querySelector('[data-add-to-cart-text]');
    if (textNode) {
      setTextIf(textNode, text);

      // Refit the label only when the label or the button width changed.
      var fitKey = text + '|' + button.clientWidth;
      if (textNode.dataset.maFitKey !== fitKey) {
        textNode.dataset.maFitKey = fitKey;
        requestAnimationFrame(function () {
          var designSize = parseFloat(getComputedStyle(button).fontSize) || CTA_LABEL_MIN_PX;
          fitTextToWidth(textNode, Math.max(0, button.clientWidth - 28), designSize, CTA_LABEL_MIN_PX);
        });
      }
    }

    var disabled = !ready || !available;
    if (button.disabled !== disabled) button.disabled = disabled;
    button.classList.toggle('is-ma-selection-disabled', !ready);
    setAttrIf(button, 'aria-disabled', disabled ? 'true' : 'false');
    setAttrIf(button, 'aria-label', text);
    rememberCtaState(button, text);
  }

  function updateUI(customizer) {
    var state = getState(customizer);

    customizer.querySelectorAll('[data-ma-option="frame"]').forEach(function (button) {
      var selected = normalize(button.dataset.value) === normalize(state.frame) && !!state.frame;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    customizer.querySelectorAll('[data-ma-option="size"]').forEach(function (button) {
      var selected = normalize(button.dataset.value) === normalize(state.size) && !!state.size;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    var frameCheck = customizer.querySelector('[data-ma-step-check="frame"]');
    var sizeCheck = customizer.querySelector('[data-ma-step-check="size"]');
    if (frameCheck) frameCheck.hidden = !state.frame;
    if (sizeCheck) sizeCheck.hidden = !state.size;

    var summaryFrame = customizer.querySelector('[data-ma-summary-frame]');
    var summarySize = customizer.querySelector('[data-ma-summary-size]');
    var summaryUnit = customizer.querySelector('[data-ma-summary-unit]');

    setTextIf(summaryFrame, state.frame || '—');
    setTextIf(summarySize, state.size ? cleanSize(state.size) : '—');
    if (summaryUnit) summaryUnit.hidden = !state.size;

    // On the phone the summary lives in the step headers instead: once a choice is made
    // "1. Choose your floater frame" reads "1. Floater frame: Oak" and "2. Choose your size"
    // reads "2. Size: 40×30 in". The value is written here; `data-ma-chosen` on the step
    // lets ma-pdp-handoff.css swap the prompt for it (mobile only, desktop keeps the prompts).
    setTextIf(customizer.querySelector('[data-ma-step-value="frame"]'), state.frame || '');
    setTextIf(customizer.querySelector('[data-ma-step-value="size"]'), state.size ? cleanSize(state.size) + ' in' : '');
    toggleAttrIf(customizer.querySelector('[data-ma-step="frame"]'), 'data-ma-chosen', !!state.frame);
    toggleAttrIf(customizer.querySelector('[data-ma-step="size"]'), 'data-ma-chosen', !!state.size);

    var section = customizer.closest('[data-ma-new-variant-design="true"], [data-is-art-piece-simple="true"], [data-is-art-piece-simple-vertical="true"]');
    var badge = section && section.querySelector('[data-ma-hero-badge]');
    if (badge) {
      var badgeParts = [];
      if (state.frame) badgeParts.push(String(state.frame).toUpperCase());
      if (state.size) badgeParts.push(cleanSize(state.size));
      setTextIf(badge, badgeParts.join(' · '));
      badge.hidden = badgeParts.length === 0;
    }

    // The handoff flag lives on the product *section*, one level above the
    // `.product-page` root this file otherwise works with.
    var handoffRoot = customizer.closest('[data-ma-handoff-pdp="true"]');
    if (handoffRoot) {
      var selectionComplete = !!(state.frame && state.size);
      var selectedVariant = selectionComplete ? findVariantForSelection(customizer, handoffRoot, state) : null;
      var selectionDetail = {
        values: [state.frame || null, state.size || null],
        options: ['Frame', 'Size'],
        complete: selectionComplete,
        variant: selectedVariant,
        soldOut: !!(selectionComplete && selectedVariant && selectedVariant.available === false)
      };
      window.__maSelection = selectionDetail;
      document.querySelectorAll('[data-ma-from]').forEach(function (el) { el.hidden = !!(state.frame || state.size); });
      document.dispatchEvent(new CustomEvent('ma:selection', { detail: selectionDetail }));
    }

    syncPurchasePrice(customizer);
    syncGuidedAddToCart(customizer);
  }

  function bindOptionButtons() {
    // Variant changes morph/re-render the product section. A listener attached
    // directly to an individual card disappears after the first selection,
    // which previously meant Frame worked but the newly rendered Size card did
    // nothing. Use one delegated listener so both selections keep working after
    // every Shopify section update.
    if (window.__maPdpOptionDelegationBound) return;
    window.__maPdpOptionDelegationBound = true;

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-ma-option]');
      if (!button) return;

      var customizer = button.closest('[data-ma-pdp-mobile]');
      if (!customizer) return;

      if (!isRedesignActive(customizer)) return;

      var kind = button.dataset.maOption;
      var value = button.dataset.value || '';
      var state = getState(customizer);
      var position = kind === 'frame'
        ? customizer.dataset.frameOptionPosition
        : customizer.dataset.sizeOptionPosition;

      if (kind === 'frame') state.frame = value;
      if (kind === 'size') state.size = value;

      updateUI(customizer);

      // Keep the theme's native selector/changeVariant path as the source of
      // truth for price, availability and gallery updates.
      triggerNativeOption(customizer, position, value);
    });
  }

  /*
    Containers this script writes into. A mutation inside one of them is our own
    doing and must not schedule another sync; otherwise the observer below feeds
    itself on every animation frame. `#pdp-price-row` (the source we clone from)
    is outside this list, so price updates from the discount script still sync.
  */
  var SELF_WRITTEN_CONTAINERS = [
    '[data-ma-purchase-pricing]',
    'shopify-payment-terms',
    'shopify-accelerated-checkout',
    '[data-ma-pdp-mobile]'
  ].join(', ');

  /*
    The add-to-cart button is written by this script *and* by the theme: a variant
    change re-enables it and resets its label. A change on the button counts as ours
    only while it still shows what the last sync applied; anything else is external
    and needs a re-sync.
  */
  function rememberCtaState(button, label) {
    button.dataset.maSyncedDisabled = String(button.disabled);
    button.dataset.maSyncedLabel = label;
  }

  function ctaMatchesLastSync(button) {
    var textNode = button.querySelector('[data-add-to-cart-text]') || button;
    return String(button.disabled) === button.dataset.maSyncedDisabled &&
      textNode.textContent === button.dataset.maSyncedLabel;
  }

  function isSelfWrittenMutation(record) {
    var node = record.target.nodeType === 1 ? record.target : record.target.parentElement;
    if (!node) return true;
    var button = node.closest('[data-add-to-cart]');
    if (button) return ctaMatchesLastSync(button);
    return !!node.closest(SELF_WRITTEN_CONTAINERS);
  }

  function observePriceAndTerms(customizer) {
    var root = getRoot(customizer);
    if (!root || root.dataset.maPdpObserved === 'true') return;
    root.dataset.maPdpObserved = 'true';

    var scheduled = false;
    var observer = new MutationObserver(function (records) {
      if (scheduled || records.every(isSelfWrittenMutation)) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        var currentCustomizer = root.querySelector('[data-ma-pdp-mobile]');
        if (!currentCustomizer || !isRedesignActive(currentCustomizer)) return;
        syncShopPay(currentCustomizer);
        syncPurchasePrice(currentCustomizer);
        syncGuidedAddToCart(currentCustomizer);
      });
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled'] // the theme toggles the add-to-cart button's disabled state
    });
  }

  function initializeCustomizer(customizer) {
    if (!isRedesignActive(customizer)) return;

    bindOptionButtons();
    updateSizeRatios(customizer);
    updateDeliveryDate(customizer);
    updateUI(customizer);
    fitDeliveryLine(customizer);
    syncShopPay(customizer);
    syncPurchasePrice(customizer);
    syncGuidedAddToCart(customizer);
    observePriceAndTerms(customizer);
  }

  function initializeAll() {
    document.querySelectorAll('[data-ma-pdp-mobile]').forEach(initializeCustomizer);
    updateReviewCount(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }

  window.addEventListener('theme:section:update', function () {
    requestAnimationFrame(function () {
      initializeAll();
      setTimeout(initializeAll, 60);
    });
  });

  /* product-price-js emits this after the existing PDP price block has fully
     applied a discount/BOGO/normal price. Sync the bottom "Your piece" price
     from that same source of truth rather than calculating a second price. */
  document.addEventListener('ma:pdp-price-updated', function () {
    document.querySelectorAll('[data-ma-pdp-mobile]').forEach(function (customizer) {
      if (isRedesignActive(customizer)) syncPurchasePrice(customizer);
    });
  });

  /*
    Re-initialise only when the viewport crosses the mobile/desktop breakpoint.
    iOS Safari fires `resize` every time its toolbar collapses while scrolling,
    so a plain resize listener would rebuild the customizer on every scroll.
  */
  function handleBreakpointChange() {
    document.querySelectorAll('[data-ma-pdp-mobile]').forEach(function (customizer) {
      if (isRedesignActive(customizer)) {
        initializeCustomizer(customizer);
      } else {
        restoreShopPay(customizer);
        restoreGuidedAddToCart(getRoot(customizer));
      }
    });
  }

  var mobileMedia = window.matchMedia(MOBILE_QUERY);
  if (typeof mobileMedia.addEventListener === 'function') {
    mobileMedia.addEventListener('change', handleBreakpointChange);
  } else {
    mobileMedia.addListener(handleBreakpointChange); // Safari < 14
  }
})();
